<div class="flex items-center" *ngrxLet="value$; let value;">
  <span>{{value}}</span>
  @if (value) {
    <button mat-icon-button
            class="text-neutral-30 ml-2"
            (click)="copyToClipboard(value)">
      <mat-icon svgIcon="content_copy"></mat-icon>
    </button>
  }
</div>
